import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'moment-duration-format';

import Article from '@zacousticrepo/grommet-v1-custom/components/Article';
import Box from '@zacousticrepo/grommet-v1-custom/components/Box';
import Button from '@zacousticrepo/grommet-v1-custom/components/Button';
import Paragraph from '@zacousticrepo/grommet-v1-custom/components/Paragraph';
import Select from '@zacousticrepo/grommet-v1-custom/components/Select';

import LikeIcon from '@zacousticrepo/grommet-v1-custom/components/icons/base/Like';
import DislikeIcon from '@zacousticrepo/grommet-v1-custom/components/icons/base/Dislike';
import NeutralIcon from '@zacousticrepo/grommet-v1-custom/components/icons/base/Subtract';

import { SurveyQuestionType, SurveyQuestionPotentialResponseType, SurveyQuestionControlType } from '../generated';

import { updateSurvey } from '../screens/_v3/Surveys/CustomerFacingSurvey/CustomerFacingSurveyActions';

class CustomerFacingSurveyControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            complete: false,
            freeTextField: undefined
        };

        this.commentSaveTimeoutId = null;
        this._onSubmitSurvey = this._onSubmitSurvey.bind(this);
        this._onUpdateSurvey = this._onUpdateSurvey.bind(this);
        this._onCommentsChange = this._onCommentsChange.bind(this);
    }

    _onSubmitSurvey() {
        this.props.survey.FreeTextFields = this.state.freeTextField ? [this.state.freeTextField] : [];
        this.props.survey.IsSubmitted = true;
        this.props.dispatch(updateSurvey(this.props.survey));
        this.setState({ complete: true });
    }

    _onUpdateSurvey({ target, option, value }) {
        const surveyQuestionId = parseInt(target.name);
        if (this._addUpdateSurveyField(surveyQuestionId, option.Id))
            this.props.dispatch(updateSurvey(this.props.survey));
    }

    _onCommentsChange({ target, option, value }) {
        this.setState({ freeTextField: { SurveyQuestionId: target.name, Value: target.value } });
        //if (this.commentSaveTimeoutId) {
        //    clearTimeout(this.commentSaveTimeoutId);
        //    this.commentSaveTimeoutId = null;
        //}
        //const commentSurveyQuestionId = target.name;
        //const message = target.value;
        //this.commentSaveTimeoutId = setTimeout(
        //    function () {
        //        let survey = JSON.parse(JSON.stringify(this.props.survey));
        //        let found = false;
        //        for (let i = 0; i < survey.Comments.length; i++) {
        //            if (survey.Comments[i].SurveyQuestionId === parseInt(commentSurveyQuestionId)) {
        //                survey.Comments[i].Value = message;
        //                found = true;
        //            }
        //        }
        //        if (!found) {
        //            survey.Comments.push({
        //                SurveyQuestionId: commentSurveyQuestionId,
        //                Id: 0,
        //                IsDeleted: false,
        //                SurveyId: survey.Id,
        //                Value: message
        //            });
        //        }

        //        this.props.dispatch(updateSurvey(survey));
        //    }.bind(this),
        //    1500
        //);
    }

    _addUpdateSurveyField(surveyQuestionId, surveyQuestionPotentialResponseId) {
        let currentField = this.props.survey.Fields.find(o => o.SurveyQuestionId === surveyQuestionId);
        if (currentField) {
            if (currentField.SurveyQuestionPotentialResponseId !== surveyQuestionPotentialResponseId) {
                currentField.SurveyQuestionPotentialResponseId = surveyQuestionPotentialResponseId;
                return true;
            }
        } else {
            currentField = {
                SurveyId: this.props.survey.Id,
                SurveyQuestionId: surveyQuestionId,
                SurveyQuestionPotentialResponseId: surveyQuestionPotentialResponseId,
                IsDeleted: false
            };
            this.props.survey.Fields.push(currentField);
            return true;
        }
        return false;
    }

    _validateSurvey(surveyQuestionsToUse) {
        const { survey } = this.props;
        let surveyComplete = true;

        surveyQuestionsToUse = surveyQuestionsToUse.filter(o => o.IsRequiredAnswered);

        surveyQuestionsToUse.forEach(surveyQuestion => {
            const field = survey.Fields.find(o => o.SurveyQuestionId === surveyQuestion.Id);
            if ((!field || !field.SurveyQuestionPotentialResponseId) && surveyQuestion.Name !== 'Comments')
                surveyComplete = false;
        });
        return surveyComplete;
    }

    render() {
        const { survey, surveyForms, surveyQuestionSearches, logoLink, customerEmail } = this.props;

        let mainNode;

        if (this.state.complete) {
            mainNode = (
                <div>
                    <div
                        style={{
                            border: '3px solid #091F40',
                            borderRadius: 30,
                            padding: 20,
                            textAlign: 'center',
                            lineHeight: '2em'
                        }}>
                        Thank you for submitting your feedback!
                    </div>
                </div>
            );
        } else {
            const surveyForm = surveyForms.find(o => o.Id === survey.SurveyFormId);
            const surveyQuestionsToUse = surveyForm.SurveyQuestions.filter(o => o.IsEnabled).sort((a, b) => a.Ordinal - b.Ordinal);
            const surveyQuestionTiles = surveyQuestionsToUse.map((surveyQuestion, index) => {
                let surveyQuestionPotentialResponseSource = surveyQuestion.Values;

                const enabledSurveyQuestionPotentialResponses = surveyQuestionPotentialResponseSource.filter(
                    o => o.IsEnabled
                );
                const displayInline = !(surveyQuestion.Id === 6 && surveyForm.ClientId === 95);
                //enabledSurveyQuestionPotentialResponses.length <= 5 &&
                //surveyQuestion.SurveyQuestionControlTypeId !== SurveyQuestionControlType.MetadataLookupField;

                const surveyField = survey.Fields.find(o => o.SurveyQuestionId === surveyQuestion.Id);
                if (surveyField && surveyField.SurveyQuestionPotentialResponse)
                    surveyField.SurveyQuestionPotentialResponse.value =
                        surveyField.SurveyQuestionPotentialResponse.Value;
                const surveyQuestionPotentialResponses = enabledSurveyQuestionPotentialResponses.map(
                    surveyQuestionPotentialResponse => {
                        const displayName =
                            surveyQuestionPotentialResponse.Value ||
                            surveyQuestionPotentialResponse.Name ||
                            surveyQuestionPotentialResponse.Id;
                        const justify = displayInline ? 'center' : 'between';
                        let displayIcon = undefined;
                        if (surveyQuestionPotentialResponse.IconType === 'Like')
                            displayIcon = (
                                <span>
                                    <LikeIcon />
                                </span>
                            );
                        else if (surveyQuestionPotentialResponse.IconType === 'DoubleLike')
                            displayIcon = (
                                <span>
                                    <LikeIcon />
                                    <LikeIcon />
                                </span>
                            );
                        else if (surveyQuestionPotentialResponse.IconType === 'Dislike')
                            displayIcon = (
                                <span>
                                    <DislikeIcon />
                                </span>
                            );
                        else if (surveyQuestionPotentialResponse.IconType === 'DoubleDislike')
                            displayIcon = (
                                <span>
                                    <DislikeIcon />
                                    <DislikeIcon />
                                </span>
                            );
                        else if (surveyQuestionPotentialResponse.IconType === 'Neutral')
                            displayIcon = (
                                <span>
                                    <NeutralIcon />
                                </span>
                            );

                        let label;

                        if (
                            surveyQuestion.SurveyQuestionPotentialResponseTypeId ===
                            SurveyQuestionPotentialResponseType.Customer
                        )
                            label = <span>{displayName}</span>;
                        else
                            label =
                                displayIcon && displayInline ? (
                                    displayIcon
                                ) : (
                                    <Box key={surveyQuestionPotentialResponse.Id} direction="row" justify={justify}>
                                        <span>{displayIcon || displayName}</span>
                                    </Box>
                                );

                        return {
                            ...surveyQuestionPotentialResponse,
                            value: displayName,
                            label
                        };

                        //return {
                        //    ...surveyQuestionPotentialResponse,
                        //    value: surveyQuestionPotentialResponse.Value || surveyQuestionPotentialResponse.Id,
                        //    label: surveyQuestionPotentialResponse.Value
                        //};
                    }
                );
                const selectedValue = surveyField
                    ? surveyQuestionPotentialResponses.find(
                        o => surveyField.SurveyQuestionPotentialResponseId === o.Id
                    ) || surveyField.SurveyQuestionPotentialResponse
                    : undefined;

                let surveyQuestionBody;
                let displayTextText = surveyQuestion.DisplayText;
                // Hack
                //displayTextText = displayTextText.replace('[ProductType]', customerLink.ProductType);
                const icdClientId = 91;
                const questionNumber = survey.ClientId === icdClientId ? undefined : `${index + 1}.`;
                if (surveyQuestion.TypeId === 3) {
                    let loadedComment = survey.Comments ? survey.Comments.find(x => x.SurveyQuestionId === surveyQuestion.Id) : undefined;
                    if (!loadedComment)
                        loadedComment = {
                            SurveyQuestionId: surveyQuestion.Id,
                            Id: 0,
                            IsDeleted: false,
                            SurveyId: survey.Id,
                            Value: ''
                        };
                    surveyQuestionBody = (
                        <div key={surveyQuestion.Id}>
                            <label className="question">
                                {questionNumber} {displayTextText}{' '}
                                {surveyQuestion.IsRequiredAnswered ? <p style={{ color: 'red' }}>Required</p> : ''}
                            </label>
                            <textarea
                                name={surveyQuestion.Id}
                                onChange={this._onCommentsChange}
                                placeholder="More Comments i.e. Our agent was professional...(optional)"
                                defaultValue={loadedComment.Value}
                            />
                        </div>
                    );
                } else if (surveyQuestion.SurveyQuestionControlTypeId === SurveyQuestionControlType.Nps) {
                    surveyQuestionBody = (
                        <div className="elevenInputRadio" key={surveyQuestion.Id}>
                            <label className="question">
                                {questionNumber} {displayTextText}{' '}
                                {surveyQuestion.IsRequiredAnswered ? <p style={{ color: 'red' }}>Required</p> : ''}
                            </label>
                            <div className="legend legend--left">0 = Very Dissatisfied</div>
                            <div className="legend legend--right">10 = Very Satisfied</div>
                            <div className="clearfix" />
                            <Select
                                key={surveyQuestion.Id}
                                inline={true}
                                placeHolder={surveyQuestion.Name}
                                name={surveyQuestion.Id}
                                onChange={this._onUpdateSurvey}
                                value={selectedValue}
                                options={surveyQuestionPotentialResponses}
                            />
                        </div>
                    );
                } else if (displayInline) {
                    let className = 'buttonInput';
                    if (surveyQuestion.Values.find(o => o.IconType)) className += ' containIcons';
                    surveyQuestionBody = (
                        <div className={className} key={surveyQuestion.Id}>
                            <label className="question">
                                {questionNumber} {displayTextText}{' '}
                                {surveyQuestion.IsRequiredAnswered ? <p style={{ color: 'red' }}>Required</p> : ''}
                            </label>
                            <Select
                                inline={true}
                                placeHolder={surveyQuestion.Name}
                                name={surveyQuestion.Id}
                                onChange={this._onUpdateSurvey}
                                value={selectedValue}
                                inlineUseButtons={true}
                                options={surveyQuestionPotentialResponses}
                            />
                        </div>
                    );
                } else {
                    surveyQuestionBody = (
                        <div className="buttonInput" key={surveyQuestion.Id}>
                            <label className="question">
                                {questionNumber} {displayTextText}{' '}
                                {surveyQuestion.IsRequiredAnswered ? <p style={{ color: 'red' }}>Required</p> : ''}
                            </label>
                            <div style={{ maxWidth: '250px' }}>
                                <Select
                                    name={surveyQuestion.Id}
                                    onChange={this._onUpdateSurvey}
                                    value={selectedValue}
                                    options={surveyQuestionPotentialResponses}
                                />
                            </div>
                        </div>
                    );
                }

                return surveyQuestionBody;
            });

            survey.surveyComplete = this._validateSurvey(surveyQuestionsToUse);
            const submitAction = survey.surveyComplete ? this._onSubmitSurvey : undefined;
            let logo = logoLink ? (
                <div style={{ padding: '10px' }}>
                    <img src={logoLink} />
                </div>
            ) : (
                <div>
                    <img src="" />
                </div>
            );
            const mlbClientId = 95;
            const tmlClientId = 96;
            let greeting = 'Dear Valued Customer';
            if (customerEmail && customerEmail.FirstName && customerEmail.FirstName.length > 0)
                greeting = 'Dear ' + customerEmail.FirstName.charAt(0).toUpperCase() + customerEmail.FirstName.slice(1);

            let greatingText =
                'Thank you for contacting us about your recent experience. We are always trying to improve our customer support and appreciate if you have a minute to provide us your feedback.';
            switch (surveyForm.ClientId) {
                case mlbClientId:
                    greatingText =
                        'Thank you for contacting Major League Baseball customer support. We are always trying to improve your experience and appreciate you taking time to provide your feedback on how we did.';
                    break;
                case tmlClientId:
                    greeting = 'Hello';
                    greatingText =
                        'Thank you for contacting Texas Health Benefits Pool. We are always trying to improve your experience and appreciate you taking time to provide your feedback on how we did.';
                    logo = logoLink ? (
                        <div style={{ padding: '10px' }}>
                            <img style={{ float: 'right' }} src={logoLink} />
                        </div>
                    ) : (
                        <div>
                            <img src="" />
                        </div>
                    );
                    break;
            }

            const submitLabelText = survey.ClientId === mlbClientId ? 'Submit' : 'Send Feedback';
            mainNode = (
                <Article
                    direction="column"
                    className="customerFacingSurveyControl"
                    style={{ border: '3px solid #091F40' }}>
                    <div className="flex flex-space-between">
                        <Paragraph className="title-primary-500-24-28">{greeting},</Paragraph>
                        {logo}
                    </div>
                    <Paragraph className="title-primary-500-24-28" style={{ maxWidth: 'unset', width: 'unset' }}>{greatingText}</Paragraph>
                    {surveyQuestionTiles}
                    <div style={{ maxWidth: '250px', margin: 'auto' }}>
                        <Button label={submitLabelText} onClick={submitAction} primary={true} backgroundColor='black' style={{ backgroundColor: '#091F40' }} />
                    </div>
                </Article>
            );
        }
        return mainNode;
    }
}

const select = (state, ownProps) => {
    return {
        ...state.customerFacingSurvey,
        ...ownProps
    };
};

export default connect(select)(CustomerFacingSurveyControl);
